import React from 'react';
import { ArrowLeft, MapPin, Mail, Phone, Building } from 'lucide-react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-32 pb-16 px-6">
      <div className="max-w-3xl mx-auto">
        {/* Back Link */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        {/* Main Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Impressum
          </h1>

          {/* Company Info */}
          <section className="mb-8">
            <div className="flex items-start gap-3 mb-4">
              <Building className="w-6 h-6 text-cyan-600 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">DYALENT Science&Technology GmbH</h2>
              </div>
            </div>
          </section>

          {/* Address */}
          <section className="mb-8">
            <div className="flex items-start gap-3">
              <MapPin className="w-6 h-6 text-cyan-600 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Adresse</h3>
                <p className="text-gray-600">
                  Hagnaustrasse 25<br />
                  4132 Muttenz<br />
                  Schweiz
                </p>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Phone className="w-5 h-5 text-cyan-600" />
              Kontakt
            </h3>
            <div className="space-y-3 pl-7">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-gray-400" />
                <span className="text-gray-600">E-Mail: </span>
                <a href="mailto:info@alpenpro.ch" className="text-cyan-600 hover:text-cyan-700 transition-colors">info@alpenpro.ch</a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-gray-400" />
                <span className="text-gray-600">Telefon: </span>
                <a href="tel:+41762652627" className="text-cyan-600 hover:text-cyan-700 transition-colors">+41 76 265 26 27</a>
              </div>
            </div>
          </section>

          {/* Responsible */}
          <section className="border-t border-gray-200 pt-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Verantwortlich für den Inhalt
            </h3>
            <p className="text-gray-600">DYALENT Science&Technology GmbH</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
